import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-afe0fafc"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "course-data"
};
const _hoisted_2 = {
  class: "link-list"
};
const _hoisted_3 = {
  class: "text"
};

const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "btn-text"
}, "更多", -1));

const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "iconfont icon-shouqi1"
}, null, -1));

const _hoisted_6 = {
  class: "course-list",
  ref: "courseListRef"
};
const _hoisted_7 = {
  key: 0,
  class: "classify-box"
};
const _hoisted_8 = ["onClick"];
const _hoisted_9 = {
  class: "course-card-list"
};
const _hoisted_10 = {
  key: 1,
  class: "no-data"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_CardHeader = _resolveComponent("CardHeader");

  const _component_ArrowDown = _resolveComponent("ArrowDown");

  const _component_el_icon = _resolveComponent("el-icon");

  const _component_CourseCard = _resolveComponent("CourseCard");

  const _component_Empty = _resolveComponent("Empty");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_CardHeader, {
    class: "course-header",
    link: `/courseList.html?type=1&name=${$props.menu.module_name}&menuId=${$props.menu.menu_id}`,
    rightStyle: {
      background: 'transparent'
    }
  }, {
    left: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createElementVNode("span", _hoisted_3, _toDisplayString($props.menu.module_name), 1)])]),
    right: _withCtx(() => [_hoisted_4, _hoisted_5]),
    _: 1
  }, 8, ["link"]), _createElementVNode("div", _hoisted_6, [$data.typeList && $data.typeList.length ? (_openBlock(), _createElementBlock("div", _hoisted_7, [_createElementVNode("ul", {
    class: _normalizeClass(["category", $data.hiddenMoreClass && 'hidden'])
  }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.typeList, item => {
    return _openBlock(), _createElementBlock("li", {
      class: _normalizeClass(["category-item", $data.typeId === item.id && 'active']),
      key: item.id,
      onClick: $event => $options.searchCourseList(item.id)
    }, _toDisplayString(item.name), 11, _hoisted_8);
  }), 128))], 2), $data.typeList.length > 4 ? (_openBlock(), _createElementBlock("span", {
    key: 0,
    class: _normalizeClass(["show-more-btn", !$data.hiddenMoreClass && 'hidden']),
    onClick: _cache[0] || (_cache[0] = (...args) => $options.handleToggleExpand && $options.handleToggleExpand(...args))
  }, [_createTextVNode(_toDisplayString($data.hiddenMoreClass ? '展开' : '收起') + " ", 1), _createVNode(_component_el_icon, {
    class: "el-icon-arrow-down"
  }, {
    default: _withCtx(() => [_createVNode(_component_ArrowDown)]),
    _: 1
  })], 2)) : _createCommentVNode("", true)])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_9, [$data.homeCourseList && $data.homeCourseList.length ? (_openBlock(true), _createElementBlock(_Fragment, {
    key: 0
  }, _renderList($data.homeCourseList, course => {
    return _openBlock(), _createBlock(_component_CourseCard, {
      class: "home-course-card",
      "course-data": course,
      key: course.id,
      "show-label": true,
      userInfo: $props.userInfo,
      authType: $data.authType,
      zhsRole: $props.zhsRole
    }, null, 8, ["course-data", "userInfo", "authType", "zhsRole"]);
  }), 128)) : (_openBlock(), _createElementBlock("div", _hoisted_10, [_createVNode(_component_Empty)]))])], 512)]);
}